// Tipuri + logică pură pentru notificări (partajate api ↔ web).
// Arhitectură pe CANALE: azi doar email (SMTP), pregătit pentru SMS ulterior.
import { EVENIMENTE_CONFIG_DEFAULT } from './evenimente.js';
export const TRIGGERE_DEFAULT = {
    contracteExpira: true, contracteExpirate: true, facturiScadente: true,
    penalitati: true, ciExpirate: true,
};
export const NOTIFICARI_CONFIG_DEFAULT = {
    activ: false,
    smtpHost: '', smtpPort: 587, smtpUser: '', smtpParola: '',
    smtpSecure: false, expeditor: '', destinatari: [],
    oraDigest: 8,
    triggere: { ...TRIGGERE_DEFAULT },
    evenimente: { ...EVENIMENTE_CONFIG_DEFAULT },
};
/**
 * Construiește liniile de digest din cifrele de alertă + trigger-ele activate.
 * PUR (fără I/O) → testabil. Întoarce doar liniile cu număr > 0 și trigger activ.
 */
export function construiesteDigest(cifre, triggere) {
    const linii = [];
    const expira = cifre.contracteExpiraAzi + cifre.contracteExpiraMaine;
    if (triggere.contracteExpira && expira > 0)
        linii.push({ cheie: 'contracteExpira', eticheta: 'Contracte care expiră azi/mâine', numar: expira });
    if (triggere.contracteExpirate && cifre.contracteExpirate > 0)
        linii.push({ cheie: 'contracteExpirate', eticheta: 'Contracte cu retur depășit', numar: cifre.contracteExpirate });
    if (triggere.facturiScadente && cifre.facturiScadente > 0)
        linii.push({ cheie: 'facturiScadente', eticheta: 'Facturi scadente neîncasate', numar: cifre.facturiScadente });
    if (triggere.penalitati && cifre.contracteCuPenalitati > 0)
        linii.push({ cheie: 'penalitati', eticheta: 'Contracte cu taxă suplimentară activă', numar: cifre.contracteCuPenalitati });
    if (triggere.ciExpirate && cifre.clientiCiExpirate > 0)
        linii.push({ cheie: 'ciExpirate', eticheta: 'Clienți cu CI expirat', numar: cifre.clientiCiExpirate });
    return linii;
}
/** Validare minimă a configurării înainte de a încerca trimiterea. */
export function configNotificariValida(c) {
    if (!c.activ)
        return { ok: false, motiv: 'Notificările sunt dezactivate.' };
    if (!c.smtpHost)
        return { ok: false, motiv: 'Lipsește serverul SMTP.' };
    if (!c.expeditor)
        return { ok: false, motiv: 'Lipsește adresa expeditorului.' };
    if (!c.destinatari.length)
        return { ok: false, motiv: 'Niciun destinatar configurat.' };
    return { ok: true };
}
//# sourceMappingURL=notificari.js.map